import page from 'page'
import React from 'react'
import { isEmpty } from 'lodash'
import plural from 'smart-plurals'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import Hide from './../components/Hide'

import { getFullInfo, getSimilar, subscribe, setFromList } from '../store/reducers/lots/single.js'
import { getLoggedUser } from '../selectors/user.js'
import { getLotName, getSimilarLots, getLotInfo, getLastBidValue } from '../selectors/lots.js'

import Comments from './Comments'
import MainContainer from './Main'
import SingleList from './LotList/singleList'
import BidOverlay from '../components/Lot/Bid'
import BidHistory from '../components/Lot/BidHistory'
import LotInfo from '../components/Lot/LotInfo'

import Overlay from '../components/Overlay'
import Checkbox from './../components/Checkbox'

import Sidebar from './../components/Lot/Sidebar'
import Timer from '../components/Lot/Timer'
import numeral from 'numeral'

import {sendViewCard, sendViewLot, sendAddToCart} from './../helpers/tagManager'
import { sendMindbox } from '../helpers/hocs'

const pluralize = plural.Plurals.getRule('ru')

const lastBidHeader = value => <span><FormattedMessage id='lot.last_bid' /><br /><nobr>{value}</nobr></span>
const lastBidHeaderComplete = value => <span><FormattedMessage id='lot.complete_last_bid' /><br /><nobr>{value}</nobr></span>

const LotPage = ({ data = {}, bids = [], similar = [], contacts = {}, name, closeBidOverlay, bidId, lastBid, nextBid, bidLength, id, user, subscribe, setBidOverlay, 
  bidOverlay, setBidLength, setShowBids, showBids, onBidAdd, currentLocale, intl, lotClosed, bidClosed, fromListNameLocal, setMindboxData }) => {
  if (!data || isEmpty(data)) return null
  nextBid = data.bidStep
  nextBid += data.bids.length ? Math.max(...data.bids.map(item => item.value)) : data.startBid - data.bidStep
  let alias = data.fund._id
  if (data.fund.alias) alias = data.fund.alias

  const isUserBid = bids.filter(el => el.targetId === user._id).length > 0
  const onClickSetBid = () => {
    sendAddToCart({...data, name}, fromListNameLocal, 1)
    setBidOverlay(true)
  }
  let Button =
    <button className='Main__founds-button Button Button_black Button_width300' style={{verticalAlign: 'top'}} onClick={onClickSetBid}>
      {isUserBid ? intl.formatMessage({id: 'lot.raise_bid'}) : intl.formatMessage({id: 'lot.place_bid'})}
    </button>

  if (data.status !== 'active' || bidClosed){
    Button = null
  }
  const howGoingMeet = {
    text: contacts.data.meeting || <FormattedMessage id='lot.info' />,
    title: <FormattedMessage id='lot.info.title' />,
    isHTML: contacts.data.meeting && contacts.data.meeting.length > 0
  }
//компонент таймера 60 минут до завершения
  let timer = <Timer data={data} time={data.secondsToFinish} lotClosed={lotClosed}/>
  if (data.status !== 'active'){
    timer = null
  }
  return (
    <MainContainer
      sidebarClass='Sidebar_person'
      Sidebar={<Sidebar data={{ ...data, name }} image={data.image} person={data.persons} meta={data.meta || {}} />}
    >
      <Helmet>
        <title>{data.meta.title}</title>
        <meta name='description' content={data.meta.description} />
        <meta property='og:title' content={data.meta.title} />
        <meta property='og:image' content={data.meta.image} />
        <meta property='og:url' content={window.location.href} />
        <meta property='og:description' content={data.meta.description} />
      </Helmet>
      {/* <LotInfo
        startBid={data.startBid}
        bidStep={data.bidStep}
        startDate={data.startDate}
        closeDate={data.closeDate}
        currency={data.currency}
      /> */}
      <BidHistory
        noLink
        noDate
        lot={data}
        id={id}
        user={user}
        title={data.status != 'complete' ? lastBidHeader(lastBid) : lastBidHeaderComplete(lastBid)}
        items={bids.slice(0, bidLength)}
        emptyTitle={intl.formatMessage({id: 'lot.make_first_bid'})}
        subtitle={bids.length ? ` 
                ${pluralize(bids.length,
                  currentLocale === 'ru' ? [
                    intl.formatMessage({id: 'lot.total_few'}),
                    intl.formatMessage({id: 'lot.total_many'}),
                    ] : [
                    intl.formatMessage({id: 'lot.total_few'}),
                    intl.formatMessage({id: 'lot.total_many'}),
                    ]
                  )
              }
            
              ${bids.length} 
              ${pluralize(bids.length,
              currentLocale === 'ru' ? [
                intl.formatMessage({id: 'common.bid'}),
                intl.formatMessage({id: 'common.bids_few'}),
                intl.formatMessage({id: 'common.bids_many'})
                ] : [
                intl.formatMessage({id: 'common.bid'}),
                intl.formatMessage({id: 'common.bids_few'})
                ]
              )
          }` : null
        }
        // onExpand={setBidLength.bind(this, bids.length)} isExpand={true} showBids={setShowBids.bind(this, true)}
        onExpand={setBidLength.bind(this, bids.length)} isExpand={true} showBids={setShowBids.bind(this)}
        show={showBids}
        nextBid={numeral(nextBid).format('0,0') +' '+ data.currency.symbol}
        timer={timer}
        CTAButton={Button}
      />
      {/* {timer} */}
      { 
        <div className='Main__description Text'>
          <div dangerouslySetInnerHTML={{ __html: data.description }} />
          { !data.hideFundsDirection &&
            <div>{data.fund._id != "5b30b97a7a86d3354a414b50" && (<FormattedMessage id='lot.moneySentTo'/>) || (<FormattedMessage id='lot.moneySentToMFC'/>)} <span style={{color: 'red'}}><a href={data.fund._id != "5b30b97a7a86d3354a414b50" ? '/funds/' + alias  : "/aboutus"}>{data.fund.name}</a></span></div>
          }
          {data.code && (<p><FormattedMessage id='lot.code' /> {data.code}</p>)}
          {!data.hideMeetingInfo && (<Hide title={howGoingMeet.title} text={howGoingMeet.text} margin={true} isHTML={howGoingMeet.isHTML}/>)}
        </div>
      
      
      }
      {!data.description && <div style={{ marginTop: 60 }} />}
      
      {user && (
        <div className='Main__founds-control Text'>
          <div className='Main__control'>
            <Checkbox checked={data.isSubscribed} onChange={subscribe} />
          </div>
          <span className='Main__control-label'>
            <FormattedMessage id='lot.follow' />
          </span>
        </div>
      )}

      {/* <Comments type='lots' entryId={id} /> */}

      <SingleList items={similar} title={intl.formatMessage({id: 'lot.you_might'})} listName={'Аукцион: Вас могут заинтересовать'} />

      <Overlay isActive={bidOverlay} onClose={closeBidOverlay}>
        <BidOverlay id={id} bidId={bidId} onSuccess={onBidAdd} isSubscribed={data.isSubscribed} setMindboxData={setMindboxData} title={data.meta.title} />
      </Overlay>
    </MainContainer>
  )
}

const mapStateToProps = state => ({
  data: getLotInfo(state),
  similar: getSimilarLots(state),
  bids: state.lots.single.bids,
  bidMessage: state.lots.single.bidMessage,
  name: getLotName(state),
  lastBid: getLastBidValue(state),
  user: getLoggedUser(state),
  fromListName: state.lots.single.fromListName,
  contacts: state.contacts
})

const mapDispatchToProps = dispatch => bindActionCreators({ getFullInfo, getSimilar, subscribe, setFromList }, dispatch)

const mergeProps = (state, dispatch, props) => ({
  ...props,
  ...state,
  getFullInfo: async (id) => {
    id = id || props.id
    if (!id) return
    let result = await dispatch.getFullInfo(id, {typelot:'lot'})
    if (result === 200) await dispatch.getSimilar(id)
    else props.on404()
  },
  onBidAdd: async (id) => {
    id = id || props.id
    if (!id) return
    let result = await dispatch.getFullInfo(id, { noRewrite: true })
    if (result === 200) {
      props.setBidOverlay(false)
      page(`/lots/${id}`)
    }
  },
  subscribe: async flag => {
    if (!props.id || !state.data) return
    await dispatch.subscribe(props.id, !state.data.isSubscribed)
  },
  clearFromList: async () => {
    dispatch.setFromList(null)
  }
})

export default injectIntl(compose(
  withState('showBids', 'setShowBids', false),
  withState('bidLength', 'setBidLength', 10000),
  withState('bidOverlay', 'setBidOverlay', null),
  withState('bidClosed', 'setBidClosed', false),
  withState('fromListNameLocal', 'setFromListNameLocal', ""),
  withState('mindboxData', 'setMindboxData', {}),
  withHandlers({
    lotClosed: (data) => (e) => {
      //скрываем кнопку Сделать ставку
      data.setBidClosed(true)
    },
    setBidOverlay: ({ setBidOverlay }) => (flag, e) => {
      e && e.preventDefault()
      setBidOverlay(flag)
    },
    setBidLength: ({ setBidLength }) => (num, e) => {
      e && e.preventDefault()
      setBidLength(num)
	  	  console.log('--------------num',num)
    },
    setShowBids: ({ setShowBids, showBids, setBidLength }) => ( e) => {
      e && e.preventDefault()
      setShowBids(!showBids)
      //if(showBids) {setBidLength(10000)} else {setBidLength(10000)}
      console.log("show bids", !showBids)
    },
    closeBidOverlay: ({ id, bidId, setBidOverlay }) => e => {
      e && e.preventDefault()
      setBidOverlay(false)
      if (bidId) page(`/lots/${id}`)
    }, 
  }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps, state => ({currentLocale: state.intl.locale})),
  lifecycle({
    componentWillMount () {
      this.props.getFullInfo()
    },
    componentDidMount () {
      this.props.bidId && this.props.setBidOverlay(true)
    },
    componentWillReceiveProps (np) {
      if (np.bidId && (np.bidId !== this.props.bidId)) this.props.setBidOverlay(true)
      if (np.id && (np.id !== this.props.id)) this.props.getFullInfo(np.id)
      if (np.similar && np.similar.length > 0 && np.similar !== this.props.similar) sendViewCard(np.similar, 'Аукцион: Вас могут заинтересовать')
      if (np.data && Object.keys(np.data).length !== 0 && (np.data !== this.props.data)) {
      //отправка данных о просмотре лота
        sendViewLot({...np.data, name: np.name}, np.fromListName)
        this.props.setFromListNameLocal(np.fromListName)
        this.props.clearFromList()
        //условие просмотра аукциона когда авторизованный пользователь только зашел на страницу и данные об аукционе подгрузились
        if ((this.props.user && Object.keys(this.props.user).length > 0) && (np.data && Object.keys(np.data).length > 0 && this.props.data && Object.keys(this.props.data).length === 0)) {
          //let match = document.cookie.match(/mindboxDeviceUUID=[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}/)
          //let UUID = match[0].split('=')[1]

          /*window.mindbox("async", {
            operation: "ProsmotrAukciona",
            data: {
              customer: {
                email: np.user.emails[0]
              },
              viewProduct: {
                productGroup: {
                  ids: {
                    website: np.data.persons[0].categoriesId && np.data.persons[0].categoriesId.length > 0 && np.data.persons[0].categoriesId[0]._id ? np.data.persons[0].categoriesId[0]._id : ''
                  }
                },
                product: {
                  ids: {
                    website: np.data._id
                  }
                },

              }
            },
            onSuccess: function() {console.log('данные о просмотре лота записались**************') },
            onError: function(error) {console.log('ошибка записи в mindbox**************', error) }
          });*/
          const mindboxData = {
            "customer": {
              "email": np.user.emails[0]
            },
            "viewProduct": {
              "product": {
                "ids": {
                  "website": np.data._id
                }
              },
            }
          }

          sendMindbox(mindboxData, 'viewLot')
        }
      }
      //отправка данных о слежении за аукционом / прекращении слежения (mindbox)
      if (this.props.user && this.props.data && Object.keys(this.props.data).length !== 0) {
        if (np.data.isSubscribed !== this.props.data.isSubscribed && (typeof np.data.isSubscribed !== 'undefined')) {

          let mindboxData
          if (np.data.isSubscribed) {
            mindboxData = {
              "customer": {
                "ids": {
                  "websiteID": this.props.user._id
                }
              },
              "productList": [
                {
                  "product": {
                    "ids": {
                      "website": this.props.data._id
                    }
                  },
                  "count": 1
                },
              ],
            }
            
            sendMindbox(mindboxData, 'monitoring')
          } else {
            mindboxData = {
              "customer": {
                "ids": {
                  "websiteID": this.props.user._id
                }
              },
              "removeProductFromList": {
                "product": {
                  "ids": {
                    "website": this.props.data._id
                  }
                },
              },
            }

            sendMindbox(mindboxData, 'demonitoring')
          }
        }
      }
      if (this.props.user && this.props.mindboxData && Object.keys(this.props.mindboxData).length > 0) {
        //проверяем что число ставок изменилось и последняя ставка точно сделана текущим пользователем - отправляем данные по ставке
        if (np.bids.length !== this.props.bids.length && np.bids[0].targetId === this.props.user._id) {
          const mindboxData = this.props.mindboxData
          mindboxData.order.ids.websiteID = np.bids[0]._id
          sendMindbox(mindboxData, 'newBid')
        } 
      }
      console.log('данные по лоту**********************', np)
    }
  })
)(LotPage))



// WEBPACK FOOTER //
// ./src/containers/Lot.jsx